// 身材管理模块配置
export const bodyConfig = {
  // 模块基本信息
  name: '身材管理',
  description: '体重、运动、饮食',
  icon: 'TrophyOutlined',
  bgColor: '#98D8C8',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    records: '/body',
    create: '/body',
    update: '/body',
    delete: '/body',
    upload: '/body/upload'
  },
  
  // BMI 分类标准
  bmiCategories: {
    underweight: { min: 0, max: 18.5, label: '偏瘦', color: '#FF6B6B', advice: '增重建议' },
    normal: { min: 18.5, max: 24.9, label: '标准', color: '#52C41A', advice: '保持建议' },
    overweight: { min: 25, max: 29.9, label: '偏胖', color: '#FAAD14', advice: '减重建议' },
    obese: { min: 30, max: 999, label: '肥胖', color: '#FF4D4F', advice: '减重建议' }
  },
  
  // 增重建议
  weightGainAdvice: {
    title: '健康增重建议',
    sections: [
      {
        title: '饮食建议',
        items: [
          '增加蛋白质摄入：鸡蛋、瘦肉、鱼类、豆制品',
          '适量增加碳水化合物：米饭、面条、土豆、红薯',
          '健康脂肪：坚果、橄榄油、牛油果',
          '多吃高热量食物：全脂牛奶、奶酪、花生酱',
          '规律进餐：每天5-6餐，不要跳过任何一餐'
        ]
      },
      {
        title: '运动建议',
        items: [
          '力量训练：哑铃、杠铃、俯卧撑、深蹲',
          '有氧运动：慢跑、游泳、骑自行车（适量）',
          '瑜伽和拉伸：改善体态，增加肌肉柔韧性',
          '每周3-4次运动，每次30-45分钟'
        ]
      },
      {
        title: '生活习惯',
        items: [
          '保证充足睡眠：每天7-8小时',
          '减少压力：冥想、深呼吸、听音乐',
          '戒烟限酒：影响食欲和营养吸收',
          '定期体检：确保增重过程健康'
        ]
      }
    ]
  },
  
  // 减重建议
  weightLossAdvice: {
    title: '健康减重建议',
    sections: [
      {
        title: '饮食建议',
        items: [
          '控制总热量：每天减少300-500卡路里',
          '增加蛋白质：鸡胸肉、鱼肉、蛋清、豆腐',
          '多吃蔬菜：绿叶菜、西兰花、胡萝卜、西红柿',
          '减少精制碳水：白米饭、白面包、甜食',
          '健康脂肪：橄榄油、坚果（适量）、牛油果',
          '多喝水：每天2-3升，饭前喝水增加饱腹感'
        ]
      },
      {
        title: '运动建议',
        items: [
          '有氧运动：快走、慢跑、游泳、骑自行车',
          '力量训练：哑铃、自重训练、瑜伽',
          '高强度间歇训练（HIIT）：燃脂效果更好',
          '每周5-6次运动，每次45-60分钟',
          '循序渐进：从低强度开始，逐渐增加'
        ]
      },
      {
        title: '生活习惯',
        items: [
          '规律作息：早睡早起，保证7-8小时睡眠',
          '控制压力：压力会导致皮质醇升高，影响减重',
          '戒掉零食：避免高糖高脂的零食',
          '细嚼慢咽：增加饱腹感，减少进食量',
          '定期称重：每周称重1-2次，记录变化'
        ]
      }
    ]
  },
  
  // 保持身材建议
  maintenanceAdvice: {
    title: '身材保持建议',
    sections: [
      {
        title: '饮食平衡',
        items: [
          '均衡营养：蛋白质、碳水化合物、脂肪比例合理',
          '多吃蔬果：每天5份蔬菜水果',
          '适量蛋白质：瘦肉、鱼类、豆制品',
          '健康脂肪：橄榄油、坚果、鱼类',
          '控制盐分：每天不超过6克',
          '规律进餐：不要暴饮暴食'
        ]
      },
      {
        title: '运动习惯',
        items: [
          '有氧运动：每周3-4次，每次30-45分钟',
          '力量训练：每周2-3次，保持肌肉量',
          '柔韧性训练：瑜伽、拉伸，每周2-3次',
          '多样化运动：避免单一运动造成的疲劳',
          '适度运动：不要过度训练'
        ]
      },
      {
        title: '生活习惯',
        items: [
          '规律作息：每天7-8小时睡眠',
          '压力管理：冥想、运动、社交活动',
          '定期体检：每年体检1-2次',
          '保持积极心态：身材管理是长期过程',
          '记录变化：定期拍照记录身材变化'
        ]
      }
    ]
  },
  
  // 餐饮搭配建议
  mealSuggestions: {
    breakfast: [
      '燕麦粥 + 鸡蛋 + 牛奶 + 水果',
      '全麦面包 + 花生酱 + 香蕉 + 酸奶',
      '玉米粥 + 豆腐 + 青菜 + 坚果',
      '红薯 + 鸡蛋 + 牛奶 + 蓝莓'
    ],
    lunch: [
      '糙米饭 + 鸡胸肉 + 西兰花 + 胡萝卜',
      '全麦面条 + 鱼肉 + 菠菜 + 西红柿',
      '藜麦 + 豆腐 + 青菜 + 坚果',
      '红薯 + 瘦肉 + 豆芽 + 海带'
    ],
    dinner: [
      '燕麦 + 牛奶 + 水果（轻食）',
      '蔬菜沙拉 + 鸡胸肉 + 坚果',
      '豆腐汤 + 青菜 + 少量米饭',
      '蒸蛋 + 青菜 + 少量红薯'
    ],
    snacks: [
      '苹果 + 坚果',
      '酸奶 + 蓝莓',
      '胡萝卜 + 花生酱',
      '香蕉 + 牛奶'
    ]
  },
  
  // 锻炼方法推荐
  exerciseMethods: {
    cardio: [
      {
        name: '快走',
        duration: '30-45分钟',
        frequency: '每天',
        benefits: '燃脂、增强心肺功能、适合初学者',
        tips: '保持挺胸抬头，手臂自然摆动'
      },
      {
        name: '慢跑',
        duration: '20-30分钟',
        frequency: '每周3-4次',
        benefits: '高效燃脂、增强心肺功能、改善心情',
        tips: '循序渐进，注意膝盖保护'
      },
      {
        name: '游泳',
        duration: '30-45分钟',
        frequency: '每周2-3次',
        benefits: '全身运动、关节友好、燃脂效果好',
        tips: '注意呼吸节奏，可以尝试不同泳姿'
      },
      {
        name: '骑自行车',
        duration: '30-60分钟',
        frequency: '每周3-4次',
        benefits: '燃脂、增强腿部力量、户外运动',
        tips: '调整座椅高度，注意交通安全'
      }
    ],
    strength: [
      {
        name: '俯卧撑',
        sets: '3组',
        reps: '10-15次',
        frequency: '每周3次',
        benefits: '增强胸肌、手臂力量、核心稳定',
        tips: '保持身体成一条直线，控制呼吸'
      },
      {
        name: '深蹲',
        sets: '3组',
        reps: '15-20次',
        frequency: '每周3次',
        benefits: '增强腿部力量、燃脂、改善体态',
        tips: '膝盖不要超过脚尖，下蹲时臀部向后'
      },
      {
        name: '平板支撑',
        duration: '30-60秒',
        sets: '3组',
        frequency: '每天',
        benefits: '增强核心力量、改善体态、预防腰痛',
        tips: '保持身体成一条直线，收紧腹部'
      },
      {
        name: '哑铃训练',
        sets: '3组',
        reps: '12-15次',
        frequency: '每周2-3次',
        benefits: '增强肌肉力量、提高基础代谢',
        tips: '选择合适的重量，注意动作标准'
      }
    ],
    flexibility: [
      {
        name: '瑜伽',
        duration: '30-60分钟',
        frequency: '每周2-3次',
        benefits: '增强柔韧性、改善体态、减压',
        tips: '从基础动作开始，注意呼吸'
      },
      {
        name: '拉伸',
        duration: '10-15分钟',
        frequency: '每天',
        benefits: '改善柔韧性、预防运动损伤、放松肌肉',
        tips: '动作要缓慢，不要过度拉伸'
      }
    ]
  }
};
